<template>
  <CRow>
    <CCol sm="5" lg="5">
      <CCard>
        <CCardHeader><b>Profile</b></CCardHeader>
        <CListGroup>
          <CListGroupItem>
            <div>
              <CRow>
                <CCol>
                  <img
                    v-bind:src="datax.data.people.photo"
                    width="200"
                    height="150"
                  />
                </CCol>

                <CCol>
                  <CRow>
                    <CCol>
                      <b> Name : </b>
                      {{
                        datax.data.people.firstname +
                          " " +
                          datax.data.people.lastname
                      }}
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol>
                      <b> Email : </b>
                      {{ datax.data.people.email }}
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol>
                      <b> Phone : </b>
                      {{ datax.data.people.phone }}
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol>
                      <b> Address 1 : </b>
                      {{ datax.data.people.address1 }}
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol>
                      <b> Address 2 : </b>
                      {{ datax.data.people.address2 }}
                    </CCol>
                  </CRow>
                  <hr />
                  <CRow>
                    <CCol>
                      <b> Status Prayer : </b>
                      <CBadge v-if="datax.data.is_responded == 0" color="danger"
                        >Need Respond</CBadge
                      >
                      <CBadge
                        v-if="datax.data.is_responded == 1"
                        color="success"
                        >Responded</CBadge
                      >
                    </CCol>
                  </CRow>
                  <div v-if="datax.data.is_responded == 1">
                    <CRow>
                      <CCol>
                        <b> Respond By : </b>
                        {{
                          datax.data.responded_by.firstname +
                            "" +
                            datax.data.responded_by.lastname
                        }}
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol>
                        <b> Respond Date : </b>
                        {{ datax.data.responded_by.firstname }}
                      </CCol>
                    </CRow>
                  </div>
                  <div v-if="datax.data.is_responded == 0" :key="item.id">
                    <CButton
                      variant="primary"
                      color="warning"
                      class="mt-2"
                      @click="deactivate(item.id)"
                      ><b>Respond</b></CButton
                    >
                  </div>
                </CCol>
              </CRow>
            </div>
          </CListGroupItem>
        </CListGroup>
      </CCard>
    </CCol>
    <CCol sm="5" lg="7">
      <CCard>
        <CCardHeader><b>Content Prayer</b></CCardHeader>

        <CListGroupItem href="#">
          Description : {{ datax.data.content }}
        </CListGroupItem>
      </CCard>
    </CCol>
    <alertmodal></alertmodal>
    <modalphotobg></modalphotobg>
    <!-- <pre>{{ $data }}</pre> -->
  </CRow>
</template>

<script>
import _ from "lodash";
import axios from "axios";

import EventBus from "@/eventBus";
import alertmodal from "@/views/alert/modal.vue";
import store from "@/store.js";

import prayer from "@/services/prayer";

export default {
  name: "prayerdetail",
  components: { alertmodal },
  data() {
    return {
      datax: [],
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {},
  methods: {
    loadData() {
      //alert(this.$route.query.Pud);
      var self = this;
      prayer
        .getPrayerbyID(this.$route.query.Pud)
        .then((res) => {
          this.datax = res;
        })
        .catch((err) => {
          var params = {
            title: "Error",
            mode: "danger",
            data: err.response.data.message,
          };
          EventBus.$emit("OPEN_MODAL_ALERT", params);
        });
    },
    deactivate(id) {
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission;
      if (typeof Permission != "undefined") {
        if (Permission.indexOf("Delete tujuan") !== -1) {
          //IF ALLOW
          if (confirm("Do you really want to change status to Responded?")) {
            prayer
              .deactivate(id)
              .then((res) => {
                EventBus.$emit("TABLE_UPDATE", true);
                var params = {
                  title: "Success",
                  mode: "success",
                  data: res.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              })
              .catch((err) => {
                var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
                };
                EventBus.$emit("OPEN_MODAL_ALERT", params);
              });
          }
          //END ALLOW
        } else {
          //IF NOT
          var params = {
            title: "Error",
            mode: "danger",
            data: "unautenticated",
          };
          EventBus.$emit("OPEN_MODAL_ALERT", params);
        }
      }
      //SET END
    },
    getPhoto(data) {
      if (data) {
        return (
          axios.defaults.baseURL + "/getfile/" + data.path + "/" + data.filename
        );
      } else {
        return axios.defaults.baseURL + "/getfile/memberphoto/no_photo.jpg";
      }
    },
  },
};
</script>
